/**
 * Défini le service actif
 * @type {string}
 */
export const SERVICE_SET_ACTIVE = 'setActive'

/**
 * Ajouter ou actualise un event
 * @type {string}
 */
export const SERVICE_SET_EVENT = 'setEvent'
